import { Screen } from '@bonanza-social/navigation';
import { CommunityJackpotRewardsScreenProps } from './CommunityJackpotRewardsScreen.types';
import CommunityJackpotRewards from '../../components/CommunityJackpotRewards/CommunityJackpotRewards';

function CommunityJackpotRewardsScreen({
  route,
}: CommunityJackpotRewardsScreenProps) {
  const { milestoneId } = route.params;

  return (
    <Screen paddingHorizontal="space-0">
      <CommunityJackpotRewards milestoneId={milestoneId} />
    </Screen>
  );
}

export default CommunityJackpotRewardsScreen;
